import { Link } from "react-router-dom";
import { FaQuoteLeft } from "react-icons/fa";
import "../css/main.scss";

function Main() {
  const testimonials = [
    {
      name: "M. R.",
      text: "The tasting notes made it easy to choose, and every tea in my order felt thoughtfully selected. I keep finding a new favorite.",
    },
    {
      name: "A. K.",
      text: "Beautiful ingredients, careful packing, and a genuinely helpful team. The whole experience felt personal from start to finish.",
    },
    {
      name: "J. L.",
      text: "The weekly tasting was relaxed and welcoming. I learned how water temperature changes a cup and left with two blends I now brew every morning.",
    },
    {
      name: "S. T.",
      text: "From the coffee to the glassware, everything feels well chosen. It is a lovely place to slow down, taste, and discover something new.",
    },
  ];

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="main">
      <main>
        <section className="main-hero">
          <div className="main-hero__overlay" />
          <div className="main-hero__content">
            <p className="eyebrow">A WORLD OF FLAVOR, ONE CUP AT A TIME</p>
            <h2>Discover Your Daily Ritual</h2>
            <p className="main-hero__text">
              Explore expressive teas, thoughtful tisanes, and carefully
              roasted coffees selected for memorable everyday brewing.
            </p>
            <Link
              to="/shop"
              className="main-button main-button--light"
              onClick={toTop}
            >
              SHOP NOW
            </Link>
          </div>
        </section>

        <section className="main-section main-section--card">
          <div className="main-ceremony">
            <img src="/main/main2.jpg" alt="Serene tea ritual setting" />
            <div className="main-ceremony__card">
              <p className="eyebrow">THE ART OF TEA CEREMONY</p>
              <h3>
                What is a <span>Tea Ceremony?</span>
              </h3>
              <p>
                Learn the art of mindful tea tasting in a soothing tea ceremony
                guided by experienced hosts in a welcoming, unhurried setting.
              </p>
              <Link to="/contact" className="main-button" onClick={toTop}>
                BOOK NOW
              </Link>
            </div>
          </div>
        </section>

        <section className="main-section">
          <div className="main-tasting">
            <div className="main-tasting__visuals">
              <div className="main-tasting__image main-tasting__image--front">
                <img src="/main/main3-1.jpg" alt="Guest holding a tasting cup" />
              </div>
              <div className="main-tasting__image main-tasting__image--back">
                <img src="/main/main3-2.jpg" alt="Guests gathered for an open tasting" />
              </div>
            </div>

            <div className="main-tasting__content">
              <p className="eyebrow">EVERY SATURDAY 10:30AM - 4:30PM</p>
              <h3>Open Tasting</h3>
              <p>
                Join us at our weekly local DFW event, where you can savor a
                curated collection of our finest teas and coffees, all on the
                house!
              </p>
              <Link to="/about" className="main-button" onClick={toTop}>
                LEARN MORE
              </Link>
            </div>
          </div>
        </section>

        <section className="main-section main-section--card">
          <div className="main-story">
            <img src="/main/main4.jpg" alt="Tea leaves being carefully sorted" />
            <div className="main-story__card">
              <p className="eyebrow">OUR SOURCING APPROACH</p>
              <h3>Chosen with Curiosity</h3>
              <p>
                Tugglefield follows each ingredient from origin to cup. We look
                for clarity, character, and balance, then taste every selection
                in small batches before it joins the collection.
              </p>
            </div>
          </div>
        </section>

        <section className="main-section main-section--testimonials">
          <div className="main-testimonials">
            <h3>What people say about us</h3>
            <div className="main-testimonials__grid">
              {testimonials.map((item) => (
                <article className="main-testimonial" key={item.name}>
                  <FaQuoteLeft className="main-testimonial__icon" />
                  <p className="main-testimonial__name">{item.name}</p>
                  <p className="main-testimonial__text">{item.text}</p>
                </article>
              ))}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default Main;
